var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#play_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#play_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.224 3.708c-.722-.858-2.055-1.208-4.6-1.208h-9.24c-2.605 0-3.96.373-4.68 1.286-.7.891-.7 2.204-.7 4.02v4.296c0 3.52.831 5.307 5.38 5.307h9.24c2.207 0 3.43-.31 4.222-1.067.811-.776 1.157-2.044 1.157-4.24V7.806c0-1.915-.054-3.236-.78-4.098m-6.38 7.141-4.197 2.193a.645.645 0 0 1-.944-.572V8.098a.645.645 0 0 1 .943-.572l4.196 2.179a.645.645 0 0 1 .002 1.144"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "play_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "play_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgPlay;